'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
exports.__esModule = true
exports.default = void 0
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _TimeDate = _interopRequireDefault(require('./TimeDate'))
var _TimeInputs = _interopRequireDefault(require('./TimeInputs'))

var _Range = _interopRequireDefault(require('./Range'))
var _utils = _interopRequireDefault(require('./Range/utils'))

var _consts = _interopRequireDefault(require('./consts'))
var _getters = _interopRequireDefault(require('./getters'))
var _setters = require('./setters')
var _setTimePartToStartEnd = _interopRequireDefault(require('./setTimePartToStartEnd'))
var _convert = _interopRequireDefault(require('./convert'))
var _fmt = _interopRequireDefault(require('./fmt'))
var _utils2 = _interopRequireDefault(require('./utils'))
var _misc = require('./misc')

/**
 * @namespace Time
 *
 *
 * @class Time
 */ var Time = function Time() {}
exports.default = Time
;(0, _defineProperty2.default)(Time, 'TimeDate', _TimeDate.default)
;(0, _defineProperty2.default)(Time, 'TimeInputs', _TimeInputs.default)
;(0, _defineProperty2.default)(Time, 'TimeRange', _Range.default)
;(0, _defineProperty2.default)(Time, 'rangeUtils', _utils.default)
;(0, _defineProperty2.default)(
  Time,
  'consts',

  _consts.default
)
;(0, _defineProperty2.default)(Time, 'convert', _convert.default)
;(0, _defineProperty2.default)(Time, 'get', _getters.default)
;(0, _defineProperty2.default)(Time, 'utils', _utils2.default)
;(0, _defineProperty2.default)(Time, 'fmt', _fmt.default)
;(0, _defineProperty2.default)(Time, 'set', _setters.set)
;(0, _defineProperty2.default)(Time, 'setTimePartToStartEnd', _setTimePartToStartEnd.default)
;(0, _defineProperty2.default)(
  Time,
  'isDate',

  _misc.isDate
)
;(0, _defineProperty2.default)(Time, 'checkTimestamp', _misc.checkTimestamp)
;(0, _defineProperty2.default)(
  Time,
  'MAX_SEC_IN_DAY',

  _consts.default.MAX_SEC_IN_DAY
)
;(0, _defineProperty2.default)(Time, 'ONE_HOUR_MS', _consts.default.ONE_HOUR_MS)
;(0, _defineProperty2.default)(Time, 'ONE_DAY_MS', _consts.default.ONE_DAY_MS)
;(0, _defineProperty2.default)(Time, 'hmsKeys', _consts.default.hmsKeys)
;(0, _defineProperty2.default)(Time, 'objDateKeys', _consts.default.objDateKeys)
;(0, _defineProperty2.default)(
  Time,
  'toStr',

  _fmt.default.toTensStr
)
;(0, _defineProperty2.default)(Time, 'hmsToSec', _convert.default.hmsToSec)
;(0, _defineProperty2.default)(Time, 'secToHms', _convert.default.secToHms)
;(0, _defineProperty2.default)(Time, 'secToHms_str', _convert.default.secToHms_str)
;(0, _defineProperty2.default)(Time, 'secToHms_arr', _convert.default.secToHms_arr)
;(0, _defineProperty2.default)(Time, 'secToHms_arrStr', _convert.default.secToHms_arrStr)
;(0, _defineProperty2.default)(Time, 'tsToSec', _convert.default.tsToSec)
;(0, _defineProperty2.default)(Time, 'tsToMs', _convert.default.tsToMs)
;(0, _defineProperty2.default)(Time, 'getObjDateFromDate', _getters.default.dateObjFromDate)
;(0, _defineProperty2.default)(Time, 'getHmsFromDate', _getters.default.hmsFromDate)
;(0, _defineProperty2.default)(Time, 'getNow', _getters.default.now)
;(0, _defineProperty2.default)(Time, 'getLastDateInMonth', _utils2.default.getLastDateInMonth)
;(0, _defineProperty2.default)(Time, 'daysBetween', _utils2.default.daysBetween)
;(0, _defineProperty2.default)(Time, 'convertFromStr', _getters.default.dateFromStr)
;(0, _defineProperty2.default)(Time, 'convertFromObj', _convert.default.fromObj)



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/index.js
// module id = 219
// module chunks = 0